import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { ArticleMagazineModel } from 'src/graphql/generated-types';
import { SharedMagazineSetMagazineAction } from 'src/app/_shared/stores/shared-magazine/shared-magazine.actions';

export class SharedMagazineStateModel {

    magazine: ArticleMagazineModel = null;

}

@Injectable()
@State<SharedMagazineStateModel>({
    name: 'magazine',
    defaults: new SharedMagazineStateModel()
})
export class SharedMagazineState {

    @Selector()
    static magazine(state: SharedMagazineStateModel): ArticleMagazineModel {
        return state?.magazine;
    }

    @Action(SharedMagazineSetMagazineAction)
    setMagazine({patchState}: StateContext<SharedMagazineStateModel>, {magazine}: SharedMagazineSetMagazineAction) {
        patchState({
            magazine
        });
    }

}
